import Setting from './setting'
export default Setting
